import { useRef, useState, useCallback } from "react";
import { useHeroIntro } from "./useHeroIntro";
import "./hero-intro.css";
import { ArrowRight, Play } from "lucide-react";
import { Link } from "react-router-dom";
import "./hero-stats-paper.css";
import { DoodleIcon } from "./DoodleIcon";
import { VideoModal } from "./VideoModal";

export const HeroSection = () => {
  const image = useRef(null);
  const phase = useHeroIntro(image);
  const [videoOpen, setVideoOpen] = useState(false);
  const closeVideo = useCallback(() => setVideoOpen(false), []);
  return <><section className={`fokeev-hero hero-intro-${phase}`} aria-labelledby="hero-title">
    {phase === "loading" && <div className="hero-preloader" role="status" aria-label="Загружаем главную страницу"><div className="hero-preloader-paper"><img src="/images/brand/fokeev-wordmark-paper-v2.svg" alt="Fokeev" /><div className="hero-preloader-track" /></div></div>}
    <div className="fokeev-hero-layout">
      <div className="fokeev-hero-copy">
        <h1 id="hero-title">Дизайн, код<br />и нейросети <span>на практике</span></h1>
        <p className="fokeev-hero-description">Короткие видеоуроки, практические задания и понятные объяснения.</p>
        <div className="hero-actions">
          <Link to="/courses" className="fokeev-primary-link">Все курсы <ArrowRight size={20} /></Link>
          <button type="button" className="hero-video-button" aria-haspopup="dialog" data-testid="home-video-trigger" onClick={() => setVideoOpen(true)}>
            <span className="hero-video-icon"><Play size={16} fill="currentColor" aria-hidden="true" /></span>Смотреть видео <small>2:13</small>
          </button>
        </div>
      </div>
      <div className="fokeev-hero-art" aria-hidden="true">
        <div className="fokeev-paper-circle" />
        <div className="hero-welcome-note editorial-handnote">Друзья, привет!</div>
        <div className="hero-collage">
          <picture style={{ display: "contents" }}>
            <source media="(max-width: 767px)" srcSet="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" />
            <img ref={image} className="hero-collage-final" src="/images/brand/learning-welcome-v4.webp" alt="" width="1536" height="1024" fetchPriority="high" />
          </picture>
          {phase === "playing" && ["book", "laptop", "pencil", "cursor", "marks"].map(part =>
            <img key={part} className={`hero-piece hero-piece-${part}`} src="/images/brand/learning-welcome-v4.webp" alt="" width="1536" height="1024" />)}
        </div>
      </div>
    </div>
    <div className="fokeev-hero-stats">
      {[
        { value: "35 000+", label: "Студентов на курсах", icon: "people" },
        { value: "13 000+", label: "Отзывов о курсах", icon: "message" },
        { value: "4,8 / 5", label: "Средняя оценка", rating: true, icon: "star" },
        { value: "25+", label: "Курсов в каталоге", icon: "books" },
      ].map((stat) => (
        <div key={stat.label} className="hero-stat"><div className="hero-stat-value"><DoodleIcon name={stat.icon} size={26} /><strong className={stat.rating ? "hero-stat-rating" : undefined}>{stat.value}</strong></div><span>{stat.label}</span></div>
      ))}
    </div>
  </section>
    <VideoModal isOpen={videoOpen} onClose={closeVideo} videoUrl="/videos/ai-development-home-v1.mp4"
      poster="/images/brand/ai-development-video-poster-v1.webp" label="AI-разработка и создание AI-агентов — видео" />
  </>;
};
